import { render, staticRenderFns } from "./SimpleProductName.vue?vue&type=template&id=2a18e500&scoped=true&"
import script from "./SimpleProductName.vue?vue&type=script&lang=js&"
export * from "./SimpleProductName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18e500",
  null
  
)

export default component.exports